// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Screening Layout ── */
.screening-layout {
  display: flex;
  width: 100%;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* ── Sidebar ── */
.screening-sidebar {
  width: 220px;
  min-width: 220px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fafbfc;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
}

.screening-sidebar-title {
  padding: 10px 16px 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 4px;
  letter-spacing: 0.3px;
}

.screening-sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
}

/* ── Nav Items ── */
.screening-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  margin: 1px 8px;
  font-size: 0.82rem;
  border-radius: 6px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
}

.screening-nav-item:hover {
  background: #f1f5f9;
}

.screening-nav-item.active {
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 600;
}

.screening-nav-item.active .screening-nav-icon {
  color: #4f46e5;
}

.screening-nav-icon {
  font-size: 0.85rem;
  width: 20px;
  text-align: center;
}

/* ── Nav Group (Tools dropdown) ── */
.screening-nav-group {
  margin: 2px 0;
}

.screening-nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 16px;
  margin: 1px 8px;
  font-size: 0.82rem;
  border-radius: 6px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
  font-weight: 500;
}

.screening-nav-header:hover {
  background: #f1f5f9;
}

.screening-nav-arrow {
  font-size: 0.55rem;
  color: #94a3b8;
  transition: transform 0.2s ease;
}

.screening-nav-arrow.expanded {
  transform: rotate(90deg);
}

.screening-nav-child {
  padding-left: 36px;
  font-size: 0.8rem;
}

/* ── Divider ── */
.screening-nav-divider {
  border-top: 1px solid #e2e8f0;
  margin: 4px 12px;
}

/* ── Content Area ── */
.screening-content {
  flex: 1 1;
  min-width: 0;
  padding: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

/* ── SectionHeading style header bar ── */
.screening-header {
  background: #1e1b4b;
  padding: 0.5em 1.2em;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 16px 16px;
  border-radius: 6px;
}

.screening-header-icon {
  color: #fff;
  font-size: 1.1rem;
}

.screening-header-title {
  color: #fff;
  font-weight: 300;
  font-size: 1rem;
  letter-spacing: 0.3px;
}

.screening-header-buttons {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.screening-header-btn {
  background: rgba(255,255,255,0.12) !important;
  border: 1px solid rgba(255,255,255,0.45) !important;
  color: #fff !important;
  border-radius: 8px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  backdrop-filter: blur(4px) !important;
  transition: all 0.2s ease !important;
}

.screening-header-btn:hover {
  background: rgba(255,255,255,0.22) !important;
  border-color: rgba(255,255,255,0.7) !important;
  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;
}

.screening-header-btn-primary {
  background: linear-gradient(135deg, #6366f1, #4f46e5) !important;
  border: none !important;
  color: #fff !important;
  border-radius: 8px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  box-shadow: 0 2px 6px rgba(99,102,241,0.2) !important;
  transition: all 0.2s ease !important;
}

.screening-header-btn-primary:hover {
  box-shadow: 0 4px 12px rgba(99,102,241,0.35) !important;
  transform: translateY(-1px) !important;
}

/* ── Page body wrapper ── */
.screening-body {
  padding: 0 16px 16px;
}

/* ── Stats Cards ── */
.screening-stats {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.screening-stat-card {
  flex: 1 1;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.screening-stat-icon {
  font-size: 1.4rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.screening-stat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.screening-stat-label {
  font-size: 0.8rem;
  color: #64748b;
}

/* ── Section title ── */
.screening-section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 12px;
  letter-spacing: 0.2px;
}

/* ── Activity List ── */
.screening-activity {
  margin-bottom: 24px;
}

.screening-activity-list {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.screening-activity-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.15s;
}

.screening-activity-item:last-child {
  border-bottom: none;
}

.screening-activity-item:hover {
  background: #f1f5f9;
}

.screening-activity-status {
  font-size: 0.9rem;
  width: 24px;
  text-align: center;
}

.screening-activity-info {
  flex: 1 1;
}

.screening-activity-name {
  font-size: 0.85rem;
  color: #1e293b;
  font-weight: 500;
}

.screening-activity-meta {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 2px;
}

.screening-activity-progress {
  font-size: 0.75rem;
  color: #4f46e5;
  font-weight: 500;
}

/* ── Quick Entry Cards ── */
.screening-quick-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.screening-quick-card {
  flex: 1 1;
  min-width: 140px;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.15s;
}

.screening-quick-card:hover {
  border-color: #6366f1;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.12);
  transform: translateY(-1px);
}

.screening-quick-icon {
  font-size: 1.8rem;
  margin-bottom: 8px;
}

.screening-quick-label {
  font-size: 0.85rem;
  color: #374151;
  font-weight: 500;
}

/* ── Template Grid ── */
.screening-template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.screening-template-card {
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  transition: all 0.15s;
}

.screening-template-card:hover {
  border-color: #6366f1;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.screening-template-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.screening-template-meta {
  font-size: 0.78rem;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 12px;
}

.screening-template-actions {
  display: flex;
  gap: 8px;
}

/* ── Workflow Editor ── */
.screening-editor-layout {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px);
}

.screening-editor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #1e1b4b;
  border-radius: 6px;
  margin: 4px 16px 12px;
}

.screening-editor-toolbar .p-button-text {
  color: #fff !important;
}

.screening-editor-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  padding: 0 16px 16px;
  gap: 12px;
}

.screening-editor-palette {
  width: 200px;
  min-width: 200px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fafbfc;
  padding: 8px;
  overflow-y: auto;
}

.screening-palette-title {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px;
}

.screening-palette-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin: 2px 0;
  font-size: 0.8rem;
  border-radius: 4px;
  cursor: grab;
  color: #374151;
  transition: background 0.15s;
}

.screening-palette-item:hover {
  background: #eef2ff;
}

.screening-palette-item:active {
  cursor: grabbing;
}

.screening-editor-canvas {
  flex: 1 1;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.screening-editor-config {
  width: 300px;
  min-width: 300px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  overflow-y: auto;
}

/* ── Tool Detail Page ── */
.screening-tool-header-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}

.screening-tool-icon-circle {
  font-size: 2rem;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.screening-tool-info {
  flex: 1 1;
}

.screening-tool-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

.screening-tool-desc {
  font-size: 0.82rem;
  color: #64748b;
  margin-top: 4px;
}

.screening-tool-detail-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.screening-tool-section {
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
}

.screening-tool-section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Run History ── */
.screening-run-item {
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.15s;
  cursor: pointer;
}

.screening-run-item:hover {
  border-color: #6366f1;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.screening-run-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.screening-run-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
}

.screening-run-id {
  font-size: 0.72rem;
  color: #94a3b8;
  font-family: monospace;
}

.screening-run-status {
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 500;
}

.screening-run-status.completed { background: #dcfce7; color: #16a34a; }
.screening-run-status.running { background: #dbeafe; color: #2563eb; }
.screening-run-status.failed { background: #fef2f2; color: #ef4444; }
.screening-run-status.cancelled { background: #f1f5f9; color: #64748b; }

.screening-run-details {
  display: flex;
  gap: 20px;
  font-size: 0.78rem;
  color: #64748b;
}

.screening-run-nodes {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.screening-run-node-dot {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
}

.screening-run-node-dot.done { background: #dcfce7; color: #16a34a; }
.screening-run-node-dot.running { background: #dbeafe; color: #2563eb; }
.screening-run-node-dot.pending { background: #f1f5f9; color: #94a3b8; }
.screening-run-node-dot.failed { background: #fef2f2; color: #ef4444; }

/* ── Results Browser ── */
.screening-results-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.screening-results-table {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.screening-results-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border-top: 1px solid #e8edf5;
  font-size: 0.82rem;
  color: #475569;
}

/* Override PrimeReact DataTable to match compounds page style */
.screening-table .p-datatable-thead > tr > th {
  background: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px !important;
  border-bottom: 2px solid #e2e8f0 !important;
  text-align: center !important;
  padding: 10px 12px !important;
}

.screening-table .p-datatable-tbody > tr {
  transition: background 0.15s ease;
}

.screening-table .p-datatable-tbody > tr:hover {
  background: #f1f5f9 !important;
}

.screening-table .p-paginator {
  background: transparent !important;
  border-top: 1px solid #e8edf5 !important;
  padding-top: 12px !important;
}

/* ── Empty State ── */
.screening-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: #94a3b8;
}

.screening-empty-icon {
  font-size: 2.5rem;
  margin-bottom: 12px;
}

.screening-empty-text {
  font-size: 0.9rem;
  color: #64748b;
  margin-bottom: 4px;
}

.screening-empty-sub {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* ── Filter pills (shared templates) ── */
.screening-filter-pill {
  padding: 4px 14px;
  border-radius: 16px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s;
}

.screening-filter-pill.active {
  background: #4f46e5;
  color: #fff;
  font-weight: 500;
}

.screening-filter-pill.inactive {
  background: #f1f5f9;
  color: #475569;
}

.screening-template-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.15s;
}

.screening-template-card:hover {
  border-color: #6366f1;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.screening-template-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.screening-template-meta {
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 12px;
}

.screening-template-actions {
  display: flex;
  gap: 8px;
}

/* ── Workflow Editor ── */
.screening-editor-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.screening-editor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 0;
}

.screening-editor-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
}

.screening-editor-palette {
  width: 200px;
  min-width: 200px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fafbfc;
  padding: 8px;
  overflow-y: auto;
  margin-right: 12px;
}

.screening-palette-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px;
}

.screening-palette-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin: 2px 0;
  font-size: 0.82rem;
  border-radius: 4px;
  cursor: grab;
  color: #374151;
  transition: background 0.15s;
}

.screening-palette-item:hover {
  background: #eef2ff;
}

.screening-palette-item:active {
  cursor: grabbing;
}

.screening-editor-canvas {
  flex: 1 1;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.screening-editor-config {
  width: 300px;
  min-width: 300px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  margin-left: 12px;
  overflow-y: auto;
}

/* ── Tool Detail Page ── */
.screening-tool-header {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.screening-tool-icon {
  font-size: 2.5rem;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #f1f5f9;
}

.screening-tool-info {
  flex: 1 1;
}

.screening-tool-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1e293b;
}

.screening-tool-desc {
  font-size: 0.85rem;
  color: #64748b;
  margin-top: 4px;
}

.screening-tool-detail-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.screening-tool-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
}

.screening-tool-section-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Run History ── */
.screening-run-item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.15s;
}

.screening-run-item:hover {
  border-color: #cbd5e1;
}

.screening-run-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.screening-run-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
}

.screening-run-id {
  font-size: 0.75rem;
  color: #94a3b8;
  font-family: monospace;
}

.screening-run-status {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 500;
}

.screening-run-status.completed { background: #dcfce7; color: #16a34a; }
.screening-run-status.running { background: #dbeafe; color: #2563eb; }
.screening-run-status.failed { background: #fef2f2; color: #ef4444; }
.screening-run-status.cancelled { background: #f1f5f9; color: #64748b; }

.screening-run-details {
  display: flex;
  gap: 20px;
  font-size: 0.8rem;
  color: #64748b;
}

.screening-run-nodes {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.screening-run-node-dot {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
}

.screening-run-node-dot.done { background: #dcfce7; color: #16a34a; }
.screening-run-node-dot.running { background: #dbeafe; color: #2563eb; }
.screening-run-node-dot.pending { background: #f1f5f9; color: #94a3b8; }
.screening-run-node-dot.failed { background: #fef2f2; color: #ef4444; }

/* ── Results Browser ── */
.screening-results-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.screening-results-table {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.screening-results-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  font-size: 0.85rem;
  color: #475569;
}

/* ── Empty State ── */
.screening-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
}

.screening-empty-icon {
  font-size: 3rem;
  margin-bottom: 12px;
}

.screening-empty-text {
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.screening-empty-sub {
  font-size: 0.82rem;
}
`, "",{"version":3,"sources":["webpack://./src/scene-pm/Projects/ProjectView/Screening/Screening.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,WAAW;EACX,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;AAC1D;;AAEA;EACE,gEAAgE;EAChE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;EACvD,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;;AAEtE,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;EAC3C,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;;AAEtE,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* ── Screening Layout ── */\n.screening-layout {\n  display: flex;\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* ── Sidebar ── */\n.screening-sidebar {\n  width: 220px;\n  min-width: 220px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fafbfc;\n  padding: 8px 0;\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n}\n\n.screening-sidebar-title {\n  padding: 10px 16px 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e293b;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 4px;\n  letter-spacing: 0.3px;\n}\n\n.screening-sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n}\n\n/* ── Nav Items ── */\n.screening-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 16px;\n  margin: 1px 8px;\n  font-size: 0.82rem;\n  border-radius: 6px;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.screening-nav-item:hover {\n  background: #f1f5f9;\n}\n\n.screening-nav-item.active {\n  background: #eef2ff;\n  color: #4f46e5;\n  font-weight: 600;\n}\n\n.screening-nav-item.active .screening-nav-icon {\n  color: #4f46e5;\n}\n\n.screening-nav-icon {\n  font-size: 0.85rem;\n  width: 20px;\n  text-align: center;\n}\n\n/* ── Nav Group (Tools dropdown) ── */\n.screening-nav-group {\n  margin: 2px 0;\n}\n\n.screening-nav-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 16px;\n  margin: 1px 8px;\n  font-size: 0.82rem;\n  border-radius: 6px;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-weight: 500;\n}\n\n.screening-nav-header:hover {\n  background: #f1f5f9;\n}\n\n.screening-nav-arrow {\n  font-size: 0.55rem;\n  color: #94a3b8;\n  transition: transform 0.2s ease;\n}\n\n.screening-nav-arrow.expanded {\n  transform: rotate(90deg);\n}\n\n.screening-nav-child {\n  padding-left: 36px;\n  font-size: 0.8rem;\n}\n\n/* ── Divider ── */\n.screening-nav-divider {\n  border-top: 1px solid #e2e8f0;\n  margin: 4px 12px;\n}\n\n/* ── Content Area ── */\n.screening-content {\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── SectionHeading style header bar ── */\n.screening-header {\n  background: #1e1b4b;\n  padding: 0.5em 1.2em;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 12px 16px 16px;\n  border-radius: 6px;\n}\n\n.screening-header-icon {\n  color: #fff;\n  font-size: 1.1rem;\n}\n\n.screening-header-title {\n  color: #fff;\n  font-weight: 300;\n  font-size: 1rem;\n  letter-spacing: 0.3px;\n}\n\n.screening-header-buttons {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n}\n\n.screening-header-btn {\n  background: rgba(255,255,255,0.12) !important;\n  border: 1px solid rgba(255,255,255,0.45) !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n  padding: 6px 14px !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  backdrop-filter: blur(4px) !important;\n  transition: all 0.2s ease !important;\n}\n\n.screening-header-btn:hover {\n  background: rgba(255,255,255,0.22) !important;\n  border-color: rgba(255,255,255,0.7) !important;\n  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;\n}\n\n.screening-header-btn-primary {\n  background: linear-gradient(135deg, #6366f1, #4f46e5) !important;\n  border: none !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n  padding: 6px 14px !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  box-shadow: 0 2px 6px rgba(99,102,241,0.2) !important;\n  transition: all 0.2s ease !important;\n}\n\n.screening-header-btn-primary:hover {\n  box-shadow: 0 4px 12px rgba(99,102,241,0.35) !important;\n  transform: translateY(-1px) !important;\n}\n\n/* ── Page body wrapper ── */\n.screening-body {\n  padding: 0 16px 16px;\n}\n\n/* ── Stats Cards ── */\n.screening-stats {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.screening-stat-card {\n  flex: 1;\n  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.screening-stat-icon {\n  font-size: 1.4rem;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n}\n\n.screening-stat-number {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.2;\n}\n\n.screening-stat-label {\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n/* ── Section title ── */\n.screening-section-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 12px;\n  letter-spacing: 0.2px;\n}\n\n/* ── Activity List ── */\n.screening-activity {\n  margin-bottom: 24px;\n}\n\n.screening-activity-list {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.screening-activity-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.screening-activity-item:last-child {\n  border-bottom: none;\n}\n\n.screening-activity-item:hover {\n  background: #f1f5f9;\n}\n\n.screening-activity-status {\n  font-size: 0.9rem;\n  width: 24px;\n  text-align: center;\n}\n\n.screening-activity-info {\n  flex: 1;\n}\n\n.screening-activity-name {\n  font-size: 0.85rem;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.screening-activity-meta {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.screening-activity-progress {\n  font-size: 0.75rem;\n  color: #4f46e5;\n  font-weight: 500;\n}\n\n/* ── Quick Entry Cards ── */\n.screening-quick-grid {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.screening-quick-card {\n  flex: 1;\n  min-width: 140px;\n  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 20px 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.screening-quick-card:hover {\n  border-color: #6366f1;\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.12);\n  transform: translateY(-1px);\n}\n\n.screening-quick-icon {\n  font-size: 1.8rem;\n  margin-bottom: 8px;\n}\n\n.screening-quick-label {\n  font-size: 0.85rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n/* ── Template Grid ── */\n.screening-template-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.screening-template-card {\n  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  transition: all 0.15s;\n}\n\n.screening-template-card:hover {\n  border-color: #6366f1;\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);\n}\n\n.screening-template-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.screening-template-meta {\n  font-size: 0.78rem;\n  color: #64748b;\n  line-height: 1.6;\n  margin-bottom: 12px;\n}\n\n.screening-template-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* ── Workflow Editor ── */\n.screening-editor-layout {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 110px);\n}\n\n.screening-editor-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 12px;\n  background: #1e1b4b;\n  border-radius: 6px;\n  margin: 4px 16px 12px;\n}\n\n.screening-editor-toolbar .p-button-text {\n  color: #fff !important;\n}\n\n.screening-editor-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  padding: 0 16px 16px;\n  gap: 12px;\n}\n\n.screening-editor-palette {\n  width: 200px;\n  min-width: 200px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fafbfc;\n  padding: 8px;\n  overflow-y: auto;\n}\n\n.screening-palette-title {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 8px;\n}\n\n.screening-palette-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  margin: 2px 0;\n  font-size: 0.8rem;\n  border-radius: 4px;\n  cursor: grab;\n  color: #374151;\n  transition: background 0.15s;\n}\n\n.screening-palette-item:hover {\n  background: #eef2ff;\n}\n\n.screening-palette-item:active {\n  cursor: grabbing;\n}\n\n.screening-editor-canvas {\n  flex: 1;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  overflow: hidden;\n  position: relative;\n}\n\n.screening-editor-config {\n  width: 300px;\n  min-width: 300px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  overflow-y: auto;\n}\n\n/* ── Tool Detail Page ── */\n.screening-tool-header-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.screening-tool-icon-circle {\n  font-size: 2rem;\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n}\n\n.screening-tool-info {\n  flex: 1;\n}\n\n.screening-tool-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.screening-tool-desc {\n  font-size: 0.82rem;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.screening-tool-detail-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.screening-tool-section {\n  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.screening-tool-section-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ── Run History ── */\n.screening-run-item {\n  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 12px;\n  transition: all 0.15s;\n  cursor: pointer;\n}\n\n.screening-run-item:hover {\n  border-color: #6366f1;\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);\n}\n\n.screening-run-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.screening-run-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.screening-run-id {\n  font-size: 0.72rem;\n  color: #94a3b8;\n  font-family: monospace;\n}\n\n.screening-run-status {\n  padding: 2px 10px;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.screening-run-status.completed { background: #dcfce7; color: #16a34a; }\n.screening-run-status.running { background: #dbeafe; color: #2563eb; }\n.screening-run-status.failed { background: #fef2f2; color: #ef4444; }\n.screening-run-status.cancelled { background: #f1f5f9; color: #64748b; }\n\n.screening-run-details {\n  display: flex;\n  gap: 20px;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.screening-run-nodes {\n  display: flex;\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.screening-run-node-dot {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.6rem;\n}\n\n.screening-run-node-dot.done { background: #dcfce7; color: #16a34a; }\n.screening-run-node-dot.running { background: #dbeafe; color: #2563eb; }\n.screening-run-node-dot.pending { background: #f1f5f9; color: #94a3b8; }\n.screening-run-node-dot.failed { background: #fef2f2; color: #ef4444; }\n\n/* ── Results Browser ── */\n.screening-results-filters {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.screening-results-table {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.screening-results-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-top: 1px solid #e8edf5;\n  font-size: 0.82rem;\n  color: #475569;\n}\n\n/* Override PrimeReact DataTable to match compounds page style */\n.screening-table .p-datatable-thead > tr > th {\n  background: #f8fafc !important;\n  color: #475569 !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.3px !important;\n  border-bottom: 2px solid #e2e8f0 !important;\n  text-align: center !important;\n  padding: 10px 12px !important;\n}\n\n.screening-table .p-datatable-tbody > tr {\n  transition: background 0.15s ease;\n}\n\n.screening-table .p-datatable-tbody > tr:hover {\n  background: #f1f5f9 !important;\n}\n\n.screening-table .p-paginator {\n  background: transparent !important;\n  border-top: 1px solid #e8edf5 !important;\n  padding-top: 12px !important;\n}\n\n/* ── Empty State ── */\n.screening-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  color: #94a3b8;\n}\n\n.screening-empty-icon {\n  font-size: 2.5rem;\n  margin-bottom: 12px;\n}\n\n.screening-empty-text {\n  font-size: 0.9rem;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.screening-empty-sub {\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n/* ── Filter pills (shared templates) ── */\n.screening-filter-pill {\n  padding: 4px 14px;\n  border-radius: 16px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.screening-filter-pill.active {\n  background: #4f46e5;\n  color: #fff;\n  font-weight: 500;\n}\n\n.screening-filter-pill.inactive {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.screening-template-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  transition: all 0.15s;\n}\n\n.screening-template-card:hover {\n  border-color: #6366f1;\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);\n}\n\n.screening-template-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.screening-template-meta {\n  font-size: 0.8rem;\n  color: #64748b;\n  line-height: 1.6;\n  margin-bottom: 12px;\n}\n\n.screening-template-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* ── Workflow Editor ── */\n.screening-editor-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.screening-editor-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 0;\n}\n\n.screening-editor-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n\n.screening-editor-palette {\n  width: 200px;\n  min-width: 200px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fafbfc;\n  padding: 8px;\n  overflow-y: auto;\n  margin-right: 12px;\n}\n\n.screening-palette-title {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 8px;\n}\n\n.screening-palette-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  margin: 2px 0;\n  font-size: 0.82rem;\n  border-radius: 4px;\n  cursor: grab;\n  color: #374151;\n  transition: background 0.15s;\n}\n\n.screening-palette-item:hover {\n  background: #eef2ff;\n}\n\n.screening-palette-item:active {\n  cursor: grabbing;\n}\n\n.screening-editor-canvas {\n  flex: 1;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  overflow: hidden;\n  position: relative;\n}\n\n.screening-editor-config {\n  width: 300px;\n  min-width: 300px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  margin-left: 12px;\n  overflow-y: auto;\n}\n\n/* ── Tool Detail Page ── */\n.screening-tool-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.screening-tool-icon {\n  font-size: 2.5rem;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #f1f5f9;\n}\n\n.screening-tool-info {\n  flex: 1;\n}\n\n.screening-tool-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.screening-tool-desc {\n  font-size: 0.85rem;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.screening-tool-detail-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.screening-tool-section {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.screening-tool-section-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ── Run History ── */\n.screening-run-item {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n  transition: all 0.15s;\n}\n\n.screening-run-item:hover {\n  border-color: #cbd5e1;\n}\n\n.screening-run-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.screening-run-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.screening-run-id {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  font-family: monospace;\n}\n\n.screening-run-status {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.screening-run-status.completed { background: #dcfce7; color: #16a34a; }\n.screening-run-status.running { background: #dbeafe; color: #2563eb; }\n.screening-run-status.failed { background: #fef2f2; color: #ef4444; }\n.screening-run-status.cancelled { background: #f1f5f9; color: #64748b; }\n\n.screening-run-details {\n  display: flex;\n  gap: 20px;\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.screening-run-nodes {\n  display: flex;\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.screening-run-node-dot {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n}\n\n.screening-run-node-dot.done { background: #dcfce7; color: #16a34a; }\n.screening-run-node-dot.running { background: #dbeafe; color: #2563eb; }\n.screening-run-node-dot.pending { background: #f1f5f9; color: #94a3b8; }\n.screening-run-node-dot.failed { background: #fef2f2; color: #ef4444; }\n\n/* ── Results Browser ── */\n.screening-results-filters {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.screening-results-table {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.screening-results-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n/* ── Empty State ── */\n.screening-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #94a3b8;\n}\n\n.screening-empty-icon {\n  font-size: 3rem;\n  margin-bottom: 12px;\n}\n\n.screening-empty-text {\n  font-size: 0.95rem;\n  margin-bottom: 4px;\n}\n\n.screening-empty-sub {\n  font-size: 0.82rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
